import { render } from "./Link.vue?vue&type=template&id=a965aaca&scoped=true&ts=true"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"

import "./Link.vue?vue&type=style&index=0&id=a965aaca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a965aaca"]])

export default __exports__